export default "__VITE_ASSET__B9m5Auqx__"